import CustomLocationIcon from '../../components/icons/LocationIcon';
import PriceWidgetComponent from '../../components/price-widget/PriceWidget';
import { Body, BodyLarge } from '../../components/Typography';
import { Box } from '@mui/material';
import { HFlex, VFlex } from '../../components/FlexContainers';
import { palette } from '../../theme/palette';
import { PrimaryButton } from '../../components/Buttons';
import { QuantityCounter as QuantityCounterComponent } from '../../components/quantity-counter/QuantityCounter';
import { styled } from '@mui/material/styles';

export const RootContainer = styled(VFlex)`
  gap: 20px;
`;

export const BranchAndPriceContainer = styled(VFlex)`
  flex-wrap: wrap;
  gap: 10px 25px;
  @media (max-width: 767px) {
    gap: 15px 25px;
  }
`;

export const PriceWidget = styled(PriceWidgetComponent)`
  .pricing-container {
    gap: 10px 40px;
  }
  @media (max-width: 767px) {
    .pricing-container {
      gap: 8px 20px;
    }
  }
`;

export const SelectLocation = styled('a')`
  width: fit-content;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  cursor: pointer;
  font-size: 16px;
  color: ${palette.custom.darkGrey};
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 22px;
`;

export const LocationIcon = styled(CustomLocationIcon)`
  color: ${palette.primary.main};
`;

export const ActionContainer = styled(Box)``;

export const Actions = styled(HFlex)`
  gap: 22px;
  height: 40px;
  @media (max-width: 768px) {
    gap: 12px;
  }
`;

export const Label = styled(Body)`
  font-weight: 400;
  @media (max-width: 767px) {
    display: none;
  }
`;

export const QuantityCounter = styled(QuantityCounterComponent)`
  height: 40px;
  flex: 0;
  border-radius: 4px;
  .quantity-container {
    width: 50px;
    text-align: center;
  }
  .quantity-update-button {
    width: 40px;
  }
  .decrement-button {
    border-right: 1px solid #ccc;
    border-radius: 5px 0px 0px 5px;
  }
  .increment-button {
    border-left: 1px solid #ccc;
    border-radius: 0px 5px 5px 0px;
  }
  @media (max-width: 767px) {
    display: none;
  }
`;

export const AddToCartButton = styled(PrimaryButton)`
  width: 100%;
  max-width: 230px;
  height: 40px;
  @media (max-width: 767px) {
    max-width: unset;
  }
`;

export const ContactUs = styled(BodyLarge)``;

export const ContactUsNumber = styled(`a`)`
  letter-spacing: 0.35px;
  color: ${palette.custom.darkGrey};
  margin-bottom: 4px;
  width: fit-content;
  font-size: 16px;
  font-weight: 700;
  text-decoration: none;
`;
